import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Violation } from 'src/app/interfaces/Violation.interface';
import { AppConfig } from 'src/app/services/app.config.services';
import { TrsEventsService } from 'src/app/services/trsevents.service';
import { ToastrService } from 'ngx-toastr';
import { LogUpload } from 'src/app/utils/log-upload';
import { AgentListInfo } from 'src/app/services/agent.list.info';
import { ViolationPopupSection, isViolationPopupSectionEnabled } from 'src/app/utils/features';
import { getFormattedDateTime } from 'src/app/utils/timeManager';
import { Subscription } from 'rxjs';
import { sanitizeString } from 'src/app/utils/sanitizer';
import Cropper from 'cropperjs';
import { TranslocoService } from '@ngneat/transloco';
import { IViolationWorkflowRequestPayload } from 'src/app/interfaces/messages';
import { generateMessage } from 'src/app/utils/messages';

@Component({
  selector: 'app-violation-approval',
  templateUrl: './violation-approval.component.html',
  styleUrls: ['./violation-approval.component.sass'],
})
export class ViolationApprovalComponent implements OnInit {
  @Input() violationData: Violation;
  @Input() displayStyle = 'block';
  @Input() selectedAgentLanId = ""; // pass from parent
  @Input() AgentProfilePic = "";
  @Input() enableEscalate: boolean = false;
  comment: string = "";
  confirmApproval: string = 'none';
  openAgreeDisagreeCommentsPopup: boolean = false;
  violationAgreeDisagreeComments: string = "";
  currentViolationAgreeDisagreeStatus: number = 3; //Status after agreeing/disagreeing
  currentViolationAgreeDisagreePendingStatus: number = 3; //Status before agreeing/disagreeing
  isCurrentViolationAgreeDisagreePending: boolean = false; // true means review is still pending
  appConfig = AppConfig.settings;
  disableEscalate: boolean;
  showFlag: boolean = false;
  selectedImageIndex: number = -1;
  imageObject: Array<object> = [];

  geolocationEnabled: boolean = false;
  isCameraPicEnabled: boolean = false;
  isScreenshotEnabled: boolean = false;
  isScreenRecordEnabled: boolean = false;
  isCameraRecordEnabled: boolean = false;
  isAgreeDisagreeEnabled: boolean = true;
  maximized: boolean;
  imageType: string;
  screenshotURL: string;
  camPicURL: string;
  screenVideoURL: string;
  camVideoURL: string;
  _profilePicUrl: string;
  logUploader: LogUpload = new LogUpload("ViolationApprovalComponent");
  subscription: Subscription;

  cropperInstance: Cropper | null = null;
  disagreeBoundingBoxes: string = "";
  selectedDisagreedLabel: string = "";
  showBoundingBoxesForViolations = ["gadgetdetected", "multiplefacedetected"];
  violationDisagreeLabels: Array<{ displayName: string, value: string }> = [];

  eventLabel: string = "";
  closeLabel: string = "";
  profilePicLabel: string = "";
  cameraPicLabel: string = "";
  maximizeLabel: string = "";
  screenshotLabel: string = "";
  screenRecordLabel: string = "";
  cameraRecordLabel: string = "";
  ipLabel: string = "";
  geolocationLabel: string = "";
  commentsLabel: string = "";
  commentHereLabel: string = "";
  superadminCommentsLabel: string = "";
  escalateLabel: string = "";
  agreeLabel: string = "";
  disagreeLabel: string = "";
  agreedLabel: string = "";
  disagreedLabel: string = "";
  doYouWantToEscalateLabel: string = "";
  disagreeWithViolationLabel: string = "";
  agreeWithViolationLabel: string = "";
  disagreedViolationLabel: string = "";
  selectDisagreeAreaLabel: string = "";
  submitLabel: string = "";
  pleaseEnterCommentsLabel: string = "";

  constructor(private trsEventService: TrsEventsService, private toastService: ToastrService, private agentListInfoService: AgentListInfo,
    private translationService: TranslocoService) { }

  @Output() CloseViolationsPopUpEvent: EventEmitter<any> = new EventEmitter();
  ngOnInit(): void {
    if (this.selectedAgentLanId != null && this.selectedAgentLanId !== "") {
      this.geolocationEnabled = isViolationPopupSectionEnabled(this.selectedAgentLanId, ViolationPopupSection.GeoLocation, this.agentListInfoService);
      this.isCameraPicEnabled = isViolationPopupSectionEnabled(this.selectedAgentLanId, ViolationPopupSection.CameraPic, this.agentListInfoService);
      this.isScreenshotEnabled = isViolationPopupSectionEnabled(this.selectedAgentLanId, ViolationPopupSection.ScreenShot, this.agentListInfoService);
      this.isScreenRecordEnabled = isViolationPopupSectionEnabled(this.selectedAgentLanId, ViolationPopupSection.ScreenRecord, this.agentListInfoService);
      this.isCameraRecordEnabled = isViolationPopupSectionEnabled(this.selectedAgentLanId, ViolationPopupSection.CameraRecord, this.agentListInfoService);
      this.isAgreeDisagreeEnabled = isViolationPopupSectionEnabled(this.selectedAgentLanId, ViolationPopupSection.AgreeDisagree, this.agentListInfoService);
    }

    this.eventLabel = this.translationService.translate("Event");
    this.closeLabel = this.translationService.translate("Close");
    this.profilePicLabel = this.translationService.translate("Profile Pic");
    this.cameraPicLabel = this.translationService.translate("Camera Pic");
    this.maximizeLabel = this.translationService.translate("Maximize");
    this.screenshotLabel = this.translationService.translate("Screen Shot");
    this.screenRecordLabel = this.translationService.translate("Screen Record");
    this.cameraRecordLabel = this.translationService.translate("Camera Record");
    this.ipLabel = this.translationService.translate("IP");
    this.geolocationLabel = this.translationService.translate("Geo Location");
    this.commentsLabel = this.translationService.translate("Comments");
    this.commentHereLabel = this.translationService.translate("Comment here");
    this.superadminCommentsLabel = this.translationService.translate("Superadmin Comments");
    this.escalateLabel = this.translationService.translate("Escalate");
    this.agreeLabel = this.translationService.translate("Agree");
    this.disagreeLabel = this.translationService.translate("Disagree");
    this.agreedLabel = this.translationService.translate("Agreed");
    this.disagreedLabel = this.translationService.translate("Disagreed");
    this.doYouWantToEscalateLabel = this.translationService.translate("Do you want to escalate?");
    this.disagreeWithViolationLabel = this.translationService.translate("Disagree with Violation?");
    this.agreeWithViolationLabel = this.translationService.translate("Agree with Violation?");
    this.disagreedViolationLabel = this.translationService.translate("Disagreed Violation");
    this.selectDisagreeAreaLabel = this.translationService.translate("Select the area you disagree with and an appropriate label from the dropdown below.");
    this.submitLabel = this.translationService.translate("Submit");
    this.pleaseEnterCommentsLabel = this.translationService.translate("Please enter comments");

    this.disableEscalate = [0, 1].includes(this.violationData.StatusCode);

    if (this.appConfig.defaults.ViolationDisagreeLabels != null && this.appConfig.defaults.ViolationDisagreeLabels.length > 0) {
      this.appConfig.defaults.ViolationDisagreeLabels.forEach((label: string) => {
        this.violationDisagreeLabels.push({ displayName: this.translationService.translate(label), value: label });
      });
      this.selectedDisagreedLabel = this.appConfig.defaults.ViolationDisagreeLabels[0];
    }


    if (this.isAgreeDisagreeEnabled === true)
      if (this.violationData.ReviewStatus != null && this.violationData.ReviewStatus !== 3)
        this.currentViolationAgreeDisagreeStatus = this.violationData.ReviewStatus;
      else {
        if (this.violationData.IsRejected === 1)
          this.currentViolationAgreeDisagreeStatus = 5;
        else
          this.isCurrentViolationAgreeDisagreePending = true;
      }

    this.refreshMediaURLs();

    this.subscription = this.trsEventService.evtDataObservable.subscribe(response => {
      if (response.eventName === "SIGNEDMEDIAURL") {
        if (response.data.ViolationId === this.violationData.ViolationId) {
          this.setMediaURLs(response.data.ScreenShotUrl, response.data.CamPicUrl, response.data.ScreenVideoUrl, response.data.CamVideoUrl, response.data.ProfilePicUrl);

          if (this.openAgreeDisagreeCommentsPopup === true && this.showBoundingBoxForDisagreeEvents() && this.isCurrentViolationAgreeDisagreePending === true && this.currentViolationAgreeDisagreePendingStatus === 5) {
            if (this.cropperInstance != null)
              this.cropperInstance.destroy();

            const cropperPreviewElement: HTMLImageElement = document.getElementById("agreeDisagreeCropperImage") as HTMLImageElement;
            cropperPreviewElement.src = this.camPicURL;

            this.cropperInstance = new Cropper(cropperPreviewElement, {
              preview: '.img-preview',
              checkCrossOrigin: false,
              crop: this.onImageCropped,
            });
          }
        }
      }
      else if (response.eventName === "DISAGREEVIOLATION") {
        if (response.data.ViolationId === this.violationData.ViolationId && response.data.ReviewStatus != null) {
          this.currentViolationAgreeDisagreeStatus = response.data.ReviewStatus;
          this.currentViolationAgreeDisagreePendingStatus = 3;
          this.isCurrentViolationAgreeDisagreePending = false;
        }
      }
    });
  }

  showLightbox(imageType: string) {
    // show image in full screen
    this.imageType = imageType;
    this.selectedImageIndex = 0;
    this.showFlag = true;

    let imageUrl = '';
    if (this.imageType == 'screenshotUrl') {
      imageUrl = this.screenshotURL;
    }
    else if (this.imageType == 'cameraPic') {
      imageUrl = this.camPicURL;
    }
    this.imageObject = [{
      image: imageUrl,
    }]
  }

  closeEventHandler() {
    this.showFlag = false;
  }

  sendData() {
    this.CloseViolationsPopUpEvent.emit('Send Data Child to Parent')//emit is a function and you can pass the value
  }

  sendEvent = (eventName: any, responseData: any): void => this.trsEventService.evtdata.next({
    "eventName": eventName,
    "data": responseData
  })

  showConfirmModal() {
    if (!this.comment) {
      this.toastService.warning(this.pleaseEnterCommentsLabel, this.commentsLabel, {
        timeOut: 3000,
      });
      return;
    }
    this.confirmApproval = "block";
  }

  closeComfirm() {
    this.confirmApproval = "none";
  }

  sendForApproval = (): void => {
    this.violationData.SenderComments = this.comment;
    let sentDateTime = getFormattedDateTime(this.appConfig.defaults.DateTimeSettings.SendInUTC);
    this.violationData.SentDateTime = sentDateTime;

    const payload: IViolationWorkflowRequestPayload = {
      EventName: "VIOLATIONWORKFLOW",
      AgentLanId: this.trsEventService.supervisorId,
      EventId: this.violationData.EventId,// Event ID
      ViolationId: this.violationData.ViolationId,// Violation Id
      AgentId: this.selectedAgentLanId,// Agent Id
      StatusCode: 0,// 0: Sent for Approval 1: Approved 2:Rejected
      SenderComments: this.comment, //Comments from Sender
      SentBy: this.trsEventService.supervisorId, // Seupervisor who is sending for Approval
      SentDateTime: sentDateTime // Date Time when request was sent
    };

    this.sendEvent("SENDFORAPPROVAL", payload);
    this.violationData.StatusCode = 0;
    this.closePopup();
  }

  submitViolationCommentsForAgreeDisagree = (): void => {
    if (this.currentViolationAgreeDisagreePendingStatus === 5 && (this.violationAgreeDisagreeComments == null || this.violationAgreeDisagreeComments === ""))
      this.toastService.warning(this.pleaseEnterCommentsLabel, this.commentsLabel, { timeOut: 3000 });
    else {
      this.violationData.ReviewStatus = this.currentViolationAgreeDisagreePendingStatus;
      this.violationData.RejectionComment = this.currentViolationAgreeDisagreePendingStatus === 5 ? this.violationAgreeDisagreeComments : "";
      this.violationData.BoundingBoxes = this.currentViolationAgreeDisagreePendingStatus === 5 && this.showBoundingBoxForDisagreeEvents() === true ? this.disagreeBoundingBoxes : "";
      this.violationData.RejectionLabel = this.currentViolationAgreeDisagreePendingStatus === 5 && this.showBoundingBoxForDisagreeEvents() === true ? this.selectedDisagreedLabel : "";

      this.sendEvent("CUSTOM_DISAGREEVIOLATION", {
        "RequestArgs": {
          "EventName": "DISAGREEVIOLATION",
          "AgentLanId": this.trsEventService.supervisorId,
          "AgentId": this.selectedAgentLanId,// Agent Id
          "EventId": this.violationData.EventId,// Event Id
          "ViolationId": this.violationData.ViolationId,// ViolationId
          "ReviewStatus": this.violationData.ReviewStatus,
          "RejectionComment": this.violationData.RejectionComment,//Comment by the person supervisor who disagreed
          "BoundingBoxes": this.violationData.BoundingBoxes,
          "RejectionLabel": this.violationData.RejectionLabel,
        },
      });
      this.hideAgreeDisagreeCommentsPopup();
    }
  }

  showAgreeDisagreeCommentsPopup = (reviewStatus: number | null): void => {
    if (this.isCurrentViolationAgreeDisagreePending === false && this.currentViolationAgreeDisagreeStatus === 4)
      //If already agreed to then no need of showing anything
      return;

    if (reviewStatus != null) {
      this.currentViolationAgreeDisagreePendingStatus = reviewStatus;

      if (reviewStatus === 5)
        this.refreshMediaURLs();
    }

    this.violationAgreeDisagreeComments = "";
    this.openAgreeDisagreeCommentsPopup = true;
  }

  onImageCropped = (cropEvent: Cropper.CropEvent): void => {
    this.disagreeBoundingBoxes = `[${cropEvent.detail.x.toFixed(2)},${cropEvent.detail.y.toFixed(2)},${cropEvent.detail.height.toFixed(2)},${cropEvent.detail.width.toFixed(2)}]`
  }

  hideAgreeDisagreeCommentsPopup = (): void => {
    if (this.cropperInstance != null)
      this.cropperInstance.destroy();

    this.openAgreeDisagreeCommentsPopup = false;
    this.violationAgreeDisagreeComments = "";
    this.disagreeBoundingBoxes = "";
  }

  closePopup() {
    this.sendData();
  }

  refreshMediaURLs = () => {
    this.sendEvent("REFRESHMEDIAURL_REQUEST", {
      "AgentLanId": this.selectedAgentLanId,
      "EventId": this.violationData.EventId,
      "ViolationId": this.violationData.ViolationId,
      "supervisorId": this.trsEventService.supervisorId,
    });
  }

  setMediaURLs = (screenshotURL: string | null, camPicURL: string | null, screenVideoURL: string | null, camVideoURL: string | null, profilePicUrl: string | null): void => {
    if (screenshotURL != null && screenshotURL !== '' && screenshotURL !== 'NA')
      this.screenshotURL = screenshotURL;
    else this.screenshotURL = "assets/images/no-data.svg";

    if (camPicURL != null && camPicURL !== '' && camPicURL !== 'NA')
      this.camPicURL = camPicURL;
    else {
      this.camPicURL = "assets/images/no-data.svg"
      this.isAgreeDisagreeEnabled = false; //Since there is no camera picture URL, no point in agree/disagree
    };

    if (screenVideoURL != null && screenVideoURL !== '' && screenVideoURL !== 'NA')
      this.screenVideoURL = screenVideoURL;
    else this.screenVideoURL = "#";

    if (camVideoURL != null && camVideoURL !== '' && camVideoURL !== 'NA')
      this.camVideoURL = camVideoURL;
    else this.camVideoURL = "#";

    if (profilePicUrl != null && profilePicUrl !== '' && profilePicUrl !== 'NA')
      this._profilePicUrl = profilePicUrl;
    else this._profilePicUrl = "#";
  }

  ngOnDestroy() {
    if (this.subscription != null)
      this.subscription.unsubscribe();
  }

  sanitizeInput = (e: any): void => {
    if (e.target != null && e.target.value != null && e.target.value !== "") {
      e.target.value = sanitizeString(e.target.value);
    }
  }

  showBoundingBoxForDisagreeEvents = (): boolean => this.showBoundingBoxesForViolations.includes(this.violationData.ViolationName.toLowerCase())
}
